import type { DeviceSettings } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { defaultDeviceSettings } from "./defaultDeviceSettings"
import { useAccount } from "src/hooks/account"

export function useDefaultDeviceSettings(): DeviceSettings {
  const { data: account } = useAccount()
  const accountId = account?.id

  return useMemo(
    () => ({
      ...defaultDeviceSettings,
      account_id: accountId ?? defaultDeviceSettings.account_id,
    }),
    [accountId],
  )
}
